"use strict"
import axios from "axios";
import { getAuthHeaders } from "./UserTokenService";

export const getRequest = async (api_url) => {
  try {
      const response = await axios.get(api_url, getAuthHeaders());
      return response;
  } catch (e) {
      console.log(e);
  }
}

export const postRequest = async (api_url, post_request) => {
  try {
      const response = await axios.post(api_url, post_request, getAuthHeaders());
      return response;
  } catch (e) {
      console.log(e);
  }
}

export const patchRequest = async (api_url, post_request) => {
  try {
      const response = await axios.patch(api_url, post_request, getAuthHeaders());
      return response;
  } catch (e) {
      console.log(e);
  }
}
